import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch", "error"];
import { useEffect } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { api } from '../utils/api';
import { LOGIN_VERIFY_PATH } from '../../api/paths';
import { getIsPreview } from '../utils/isPreview';
import { usageTracker } from '../utils/usageTracker';
const GET_LOGIN_VERIFY = 'getLoginVerify';
export const FORBIDDEN_ERROR_MESSAGE = 'Forbidden';
const getLoginVerify = async () => {
  const {
    isPreview
  } = getIsPreview();
  if (isPreview) {
    return {
      email: 'preview@example.com'
    };
  }
  const response = await api(LOGIN_VERIFY_PATH);
  return response.json();
};
const GET_LOGIN_VERIFY_QUERY = registerQuery({
  fieldName: GET_LOGIN_VERIFY,
  fetcher: getLoginVerify
});
export const useLoginVerify = () => {
  var _data$GET_LOGIN_VERIF;
  const _useQuery = useQuery(GET_LOGIN_VERIFY_QUERY),
    {
      data,
      loading,
      refetch,
      error
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  const email = data === null || data === void 0 || (_data$GET_LOGIN_VERIF = data[GET_LOGIN_VERIFY]) === null || _data$GET_LOGIN_VERIF === void 0 ? void 0 : _data$GET_LOGIN_VERIF.email;
  useEffect(() => {
    if (email) {
      usageTracker.setProperties({
        email
      });
      // TODO: remove when migrated to Portals Platform earlyRequester
      usageTracker.track('Portals Platform', 'Portal Initialized', {});
    }
  }, [email]);
  const isForbidden = (error === null || error === void 0 ? void 0 : error.message) === FORBIDDEN_ERROR_MESSAGE;
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data[GET_LOGIN_VERIFY],
    refetch,
    loading,
    error,
    isForbidden
  }, rest);
};